import React from 'react';

const EmptyStateList = () => (
    <svg fill="none" height="34" viewBox="0 0 96 34" width="96" xmlns="http://www.w3.org/2000/svg">
        <circle cx="3" cy="3" fill="#CCD5E6" r="3" />
        <circle cx="3" cy="17" fill="#CCD5E6" r="3" />
        <circle cx="3" cy="31" fill="#F0F0F0" r="3" />
        <rect fill="url(#paint0_linear)" height="6" rx="3" width="84" x="12" />
        <rect fill="url(#paint0_linear)" height="6" rx="3" width="84" x="12" y="14" />
        <rect fill="url(#paint0_linear)" height="6" rx="3" width="84" x="12" y="28" />
        <defs>
            <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear" x1="18.5333" x2="99.7333" y1="30" y2="30">
                <stop stopColor="#EFEFEF" />
                <stop offset="1" stopColor="#EFEFEF" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>
);

export default EmptyStateList;
